<template>
	<div class="container switch-page">
		<header-bar name='工作台' :prev='false' />
		<div class="wrapper">
			<div class="main-box">
				<div class="name">
					<img class="ico" src="~assets/images/icon-tit_counter.png" />
					<div class="txt">待办统计</div>
				</div>
				<div class="wrap total">
					<div class="item">
						<div class="num">{{ attendantCount }}</div>
						<div class="inf">待审陪诊人</div>
					</div>
					<div class="item">
						<div class="num">{{ complaintCount }}</div>
						<div class="inf">待处理投诉</div>
					</div>
				</div>
			</div>

			<div class="main-box">
				<div class="name">
					<img class="ico" src="~assets/images/icon-tit_task.png" />
					<div class="txt">快捷导航</div>
				</div>
				<div class="wrap links">
					<div class="item" data-link='member-list' @click="handlerClick">
						<img class="icon" src="~assets/images/icon-feedback.png" />
						<div class="text">账号审核</div>
					</div>
          <div class="item" data-link='order-list' @click="handlerClick">
            <img class="icon" src="~assets/images/icon-order.png" />
            <div class="text">订单管理</div>
          </div>
					<div class="item" data-link='service-list' @click="handlerClick">
						<img class="icon" src="~assets/images/icon-member.png" />
						<div class="text">投诉处理</div>
					</div>
				</div>
			</div>

			<div class="main-box">
				<div class="name">
					<img class="ico" src="~assets/images/icon-tit_arrow.png" />
					<div class="txt">最近待审陪诊人</div>
				</div>

				<!-- loading加载区域 -->
				<div class="loading-list" v-if="!isComplete">
					<van-loading type="spinner" />
				</div>

				<!-- 无数据 -->
				<empty text='目前暂无待审陪诊人' v-if="arrEmployee.length == 0 && isComplete" />
				<!-- 有数据 -->
				<div class="wrap users" v-if="arrEmployee.length > 0 && isComplete">
					<div class="list">
						<div class="item"
						v-for="(item, index) in arrEmployee"
						:key='index'
						:data-id='item.id'
						@click="handlerMemberDetail">
							<div class="text">
								<div class="name" :class="item.sex== 0? 'name-male' : 'name-female'">{{item.name}}</div>
								<div class="age">{{ item.age }}</div>
							</div>
							<div class="info">
								<div class="row">
									<div class="lab">联系方式</div>
									<div class="inf">{{item.phone}}</div>
								</div>
								<div class="row">
									<div class="lab">居住城市</div>
									<div class="inf">{{item.address}}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="link" @click="seeMore()">查看更多</div>
				</div>
			</div>
		</div>

		<!-- 底部导航 -->
		<footer-bar :menu='arrMenu' :hov='0' />
	</div>
</template>

<script>
	import HeaderBar from 'components/HeaderBar/HeaderBar'
	import FooterBar from 'components/FooterBar/FooterBar'
	import Empty from 'components/Empty/Empty'
  import { statisticalGetComplaintCount, statisticalGetAttendantCount, attendantList } from '@/api/home'
  import { passportUserInfo } from '@/api/login'

	export default{
		name: 'Home',
		components: {
			HeaderBar,
			FooterBar,
			Empty
		},
		data(){
			return {
				arrEmployee: [],
				arrMenu: [],

				isComplete: false,
        complaintCount: 0,
        attendantCount: 0,
			}
		},
		methods: {
			handlerClick: function(e){
				let eLink = e.currentTarget.dataset.link
				this.$router.push({
					path: `/${eLink}`
				})
			},


			// 跳转陪诊人详情
			handlerMemberDetail: function(e){
				let eId = e.currentTarget.dataset.id
				console.log(eId)
				this.$router.push({
					path: '/member-detail',
					query: {
						id: eId
					}
				})
			},

			// 读取待审陪诊人数据
			loadMemberData: function(){
			  //待处理投诉数
        statisticalGetComplaintCount().then(res => {
          this.complaintCount = res.result;
        })

        //待审陪诊人数
        statisticalGetAttendantCount().then(res => {
          this.attendantCount = res.result;
        })

        //审陪诊人列表
        attendantList({pageNumber: 1, pageSize: 5, state: 6 }).then(res => {
          this.arrEmployee = res.records
          this.isComplete = true
        }).catch(() => {
          this.isComplete = true
        })
			},
      seeMore: function() {
        this.$router.push({
          path: '/member-list'
        })
      }
		},
		mounted: function(){

			// 初始化底部导航
			this.arrMenu.push({
				name: '工作台',
				icon: require('assets/images/nav/icon-nav1.png'),
				icon_hov: require('assets/images/nav/icon-nav1_hov.png'),
				link: 'home',
			})
			this.arrMenu.push({
				name: '我的',
				icon: require('assets/images/nav/icon-nav2.png'),
				icon_hov: require('assets/images/nav/icon-nav2_hov.png'),
				link: 'profile',
			})

      passportUserInfo().then(res => {
        this.loadMemberData()
      })
		}
	}
</script>

<style scoped>
.main-box{ margin: 0 0.2rem 0;}
.main-box>.name{ height: 0.96rem; line-height: 0.96rem; display: flex; justify-content: flex-start; align-items: center;}
.main-box>.name>.ico{ width: 0.4rem; height: 0.4rem; margin: 0 0.16rem 0 0;}
.main-box>.name>.txt{ font-size: 0.3rem; font-weight: 600;}
.main-box>.wrap{ background: #FFF; border-radius: 0.2rem;}


.total{ padding: 0.3rem 0; display: flex; justify-content: space-between; align-items: center;}
.total>.item{ position: relative; flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center;}
.total>.item::after{ position: absolute; content: ''; width: 1px; background: #e1e1e1; top: 0; bottom: 0; right: 0;}
.total>.item:last-of-type::after{ display: none;}
.total>.item>.num{ color: #111; font-size: 0.48rem; font-weight: 600; height: 0.72rem; line-height: 0.72rem;}
.total>.item>.inf{ color: #888; height: 0.4rem; line-height: 0.4rem;}

.links{ padding: 0.3rem 0 0.1rem; display: flex; justify-content: space-between; align-items: center;}
.links>.item{ flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center;}
.links>.item>.icon{ width: 0.96rem; height: 0.96rem;}
.links>.item>.text{ color: #111; height: 0.72rem; line-height: 0.72rem; font-size: 0.28rem}

.users{}
.users>.list{ padding: 0 0.2rem;}
.users>.list>.item{ position: relative; padding: 0 0 0.2rem;}
.users>.list>.item::after{ position: absolute; content: ''; left: 0; right: 0; bottom: 0; height: 1px; background: #e1e1e1;}
.users>.list>.item>.text{ color: #333; height: 0.88rem; display: flex; justify-content: space-between; align-items: center;}
.users>.list>.item>.text>.name{ font-size: 0.28rem; font-weight: 600; display: flex; justify-content: flex-start; align-items: center;}
.users>.list>.item>.text>.name::before{ position: relative; content: ''; margin: 0 0.12rem 0 0; width: 0.36rem; height: 0.36rem; background-size: cover !important; background-position: 50% 50% !important;}
.users>.list>.item>.text>.name-male::before{ background: url('~assets/images/icon-male.png');}
.users>.list>.item>.text>.name-female::before{ background: url('~assets/images/icon-female.png');}
.users>.list>.item>.info{ font-size: 0.28rem; padding: 0 0 0.1rem;}
.users>.list>.item>.info>.row{ height: 0.4rem; line-height: 0.4rem; display: flex; justify-content: space-between; align-items: center;}
.users>.list>.item>.info>.row>.lab{ color: #999;}
.users>.list>.item>.info>.row>.inf{ color: #555;}
.users>.link{ height: 0.88rem; line-height: 0.88rem; text-align: center; color: #3f58fd; font-size: 0.28rem;}
</style>
